(() => {
  if (customElements.get('akon-black-friday')) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const priority = ['hip-thrust-basico', 'squat-rack-olaf-rack-de-sentadillas-olaf', 'kettlebell-competicion-akf', 'cajon-pliometrico-foam', 'mancuerna-hexagonal-peso-individual', 'barra-olimpica-drakkar-camo', 'xybrid-air-ski-sp-line', 'gym-bag-pro', 'banco-reclinable-daven', 'gusano-para-3-atletas', 'maquina-dual-hack-prensa-inclinada', 'wall-ball-pro'];
  const parts = seconds => ({ days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 });
  const paintClock = (nodes, seconds, attribute) => {
    const values = parts(Math.max(0, Math.floor(seconds)));
    nodes.forEach(node => {
      const text = String(values[node.getAttribute(attribute)]).padStart(2, '0');
      if (node.textContent !== text) {
        const initialized = node.textContent !== '—';
        node.textContent = text;
        if (initialized && !reducedMotion.matches && !document.hidden && !node.closest('[hidden]')) {
          node.animate([{ opacity: .55, transform: 'translateY(3px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 180, easing: 'ease-out' });
        }
      }
    });
  };
  class AkonBlackFriday extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.products = [...this.querySelectorAll('[data-product]')];
      this.isLanding = this.hasAttribute('data-week-one-landing');
      const firstWave = this.querySelector('[data-landing-first-wave]');
      if (firstWave) {
        const products = [...firstWave.querySelectorAll('[data-product]')];
        const buttons = [...this.querySelectorAll('[data-filter]')];
        const result = this.querySelector('[data-result-count]');
        const filterProducts = filter => {
          let count = 0;
          products.forEach(product => {
            product.hidden = filter !== 'all' && product.dataset.category !== filter;
            if (!product.hidden) count++;
          });
          buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === filter)));
          result.textContent = count === 1 ? '1 producto' : `${count} productos`;
        };
        buttons.forEach(button => button.addEventListener('click', () => filterProducts(button.dataset.filter), options));
        filterProducts('all');
      }
      this.filter = 'all';
      this.offset = Number(this.isLanding ? this.dataset.serverNow : this.dataset.effectiveNow) * 1000 - Date.now();
      this.isPreview = !this.isLanding && this.dataset.preview === 'true';
      this.lockedStyle = ['cards', 'mystery', 'mixed'].includes(this.dataset.lockedStyle) ? this.dataset.lockedStyle : 'mystery';
      if (this.isPreview) {
        const requestedStyle = new URL(window.location.href).searchParams.get('bf_teaser');
        if (['cards', 'mystery', 'mixed'].includes(requestedStyle)) this.lockedStyle = requestedStyle;
      }
      this.dataset.lockedStyle = this.lockedStyle;
      this.start = Number(this.dataset.start) * 1000;
      this.end = Number(this.dataset.end) * 1000;
      this.loadedAt = this.now();
      this.weeks = [...this.querySelectorAll('[data-week]')].map(element => {
        const week = {
          element,
          start: Number(element.dataset.weekStart) * 1000,
          products: [...element.querySelectorAll('[data-product]')],
          teasers: [...element.querySelectorAll('[data-teaser]')],
          grid: element.querySelector('[data-products]'),
          tease: element.querySelector('[data-week-tease]'),
          timer: element.querySelector('[data-week-timer]'),
          clock: [...element.querySelectorAll('[data-week-time]')],
          live: element.querySelector('[data-week-live]'),
          more: element.querySelector('[data-week-more]'),
          button: element.querySelector('[data-load-week]'),
          count: element.querySelector('[data-week-count]'),
          cardNote: element.querySelector('[data-week-card-note]'),
          limit: 4
        };
        week.products.sort((a, b) => {
          const rank = product => { const index = priority.indexOf(product.dataset.handle); return index < 0 ? 999 : index; };
          return rank(a) - rank(b);
        }).forEach(product => week.grid.append(product));
        week.button.addEventListener('click', () => {
          week.limit = week.products.length;
          this.renderProducts();
        }, options);
        return week;
      });
      if (!this.isLanding) this.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => this.setFilter(button.dataset.filter), options));
      const previewSelect = this.querySelector('[data-preview-date]');
      const styleSelect = this.querySelector('[data-preview-style]');
      if (styleSelect && this.isPreview) {
        styleSelect.value = this.lockedStyle;
        styleSelect.addEventListener('change', () => {
          this.lockedStyle = ['cards', 'mystery', 'mixed'].includes(styleSelect.value) ? styleSelect.value : 'mystery';
          this.dataset.lockedStyle = this.lockedStyle;
          const url = new URL(window.location.href);
          url.searchParams.set('bf_teaser', this.lockedStyle);
          window.history.replaceState(null, '', url);
          this.weeks.forEach(week => { week.limit = 4; });
          this.renderProducts();
        }, options);
      }
      if (previewSelect && this.isPreview) {
        const dateKey = new Date(this.now()).toISOString().slice(0, 10);
        const option = [...previewSelect.options].find(item => item.value.startsWith(dateKey));
        if (option) previewSelect.value = option.value;
        previewSelect.addEventListener('change', () => {
          const time = Date.parse(previewSelect.value);
          if (!Number.isFinite(time)) return;
          this.offset = time - Date.now();
          this.querySelector('[data-preview-label]').textContent = new Intl.DateTimeFormat('es-ES', { timeZone: 'Europe/Madrid' }).format(time);
          this.weeks.forEach(week => { week.limit = 4; });
          this.updateState();
        }, options);
      }
      this.clock = [...this.querySelectorAll('[data-time]')];
      this.updateState();
      reducedMotion.addEventListener('change', () => this.setupMotion(), options);
      this.setupMotion();
      clearInterval(this.timer);
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.revealObserver?.disconnect();
      this.ambientObserver?.disconnect();
      clearInterval(this.timer);
    }
    setupMotion() {
      this.revealObserver?.disconnect();
      this.ambientObserver?.disconnect();
      this.classList.remove('bf26-motion-ready');
      if (reducedMotion.matches || !('IntersectionObserver' in window)) return;
      const elements = this.querySelectorAll('.bf26-hero__heading > *, .bf26-hero__copy, .bf26-hero__discount, .bf26-countdown-bar, .bf26-section-heading, .bf26-filter-bar, .bf26-week, .bf26-closing, .bf26-pro > *, .bf26-faq > *, .bf26-finale');
      this.revealObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          this.revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
      elements.forEach((element, index) => {
        element.setAttribute('data-bf-reveal', '');
        element.style.setProperty('--bf-reveal-delay', `${index < 4 ? index * 70 : 0}ms`);
        this.revealObserver.observe(element);
      });
      this.ambientObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => entry.target.classList.toggle('is-in-view', entry.isIntersecting));
      });
      this.querySelectorAll('.bf26-hero, .bf26-week').forEach(element => this.ambientObserver.observe(element));
      this.classList.add('bf26-motion-ready');
    }
    now() { return Date.now() + this.offset; }
    state() { return this.now() < this.start ? 'upcoming' : this.now() >= this.end ? 'ended' : 'active'; }
    setFilter(filter) {
      this.filter = filter;
      this.weeks.forEach(week => { week.limit = 4; });
      this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === filter)));
      this.renderProducts();
    }
    eligible(product) {
      return this.state() === 'active' && this.now() >= Number(product.dataset.start) * 1000 && this.now() < Number(product.dataset.end) * 1000 && (this.isPreview || product.dataset.sale === 'true');
    }
    matches(item) { return this.filter === 'all' || item.closest('[data-week]')?.dataset.weekDay === this.filter; }
    renderProducts() {
      const state = this.state();
      const active = this.products.filter(product => this.eligible(product));
      const matching = active.filter(product => this.matches(product));
      let shown = 0;
      let visibleWeeks = 0;
      const overview = this.querySelector('[data-campaign-overview]');
      if (overview) overview.hidden = state === 'ended' || (this.filter !== 'all' && this.filter !== '09');
      this.weeks.forEach(week => {
        const products = week.products.filter(product => this.eligible(product) && this.matches(product));
        const teasers = week.teasers.filter(item => this.matches(item));
        const locked = this.now() < week.start;
        const pending = !locked && products.length === 0;
        const blurredCards = locked && (this.lockedStyle === 'cards' || (this.lockedStyle === 'mixed' && week.element.dataset.weekDay === '09'));
        const displayedProducts = blurredCards ? week.products.filter(product => this.matches(product)) : products;
        week.element.hidden = state === 'ended' || teasers.length === 0;
        if (!week.element.hidden) visibleWeeks++;
        week.element.classList.toggle('is-locked', locked);
        week.element.classList.toggle('is-pending', pending);
        week.element.dataset.weekState = state === 'ended' ? 'ended' : locked ? 'locked' : pending ? 'pending' : 'open';
        week.timer.hidden = !locked;
        week.live.hidden = locked;
        week.element.querySelector('[data-week-status]').textContent = pending ? 'PREPARANDO OFERTAS' : 'YA DISPONIBLE';
        week.grid.hidden = (locked && !blurredCards) || pending;
        week.grid.classList.toggle('bf26-grid--teaser', blurredCards);
        week.grid.inert = pending || (locked && !blurredCards);
        if (week.grid.inert) week.grid.setAttribute('aria-hidden', 'true');
        else week.grid.removeAttribute('aria-hidden');
        week.cardNote.hidden = !blurredCards;
        week.tease.hidden = blurredCards || (!locked && !pending);
        week.element.querySelector('[data-week-reveal]').textContent = pending ? 'PREPARANDO LA SIGUIENTE SERIE.' : 'LO BUENO SE HACE ESPERAR.';
        week.element.querySelector('[data-week-reveal-copy]').textContent = pending ? 'Vuelve pronto para descubrir el material de esta tanda.' : `Esta tanda se abre el ${Number(week.element.dataset.weekDay)} de noviembre.`;
        const visible = new Set(displayedProducts.slice(0, week.limit));
        week.products.forEach(product => {
          product.hidden = !visible.has(product);
          product.querySelector('.bf26-product__card').inert = blurredCards;
          product.querySelector('.bf26-product__teaser-link').hidden = !blurredCards;
        });
        shown += locked ? 0 : visible.size;
        const teased = new Set(teasers.slice(0, 4));
        week.teasers.forEach(item => { item.hidden = !teased.has(item); });
        week.more.hidden = (locked && !blurredCards) || pending;
        week.button.hidden = displayedProducts.length <= week.limit;
        week.count.textContent = displayedProducts.length ? `Mostrando ${Math.min(week.limit, displayedProducts.length)} de ${displayedProducts.length} productos${blurredCards ? ' · Próximamente' : ''}` : '';
      });
      if (this.isLanding) return;
      const upcomingCount = this.weeks.reduce((sum, week) => sum + week.teasers.filter(item => this.matches(item)).length, 0);
      this.querySelector('[data-total-count]').textContent = state === 'upcoming' ? '' : String(active.length);
      this.querySelector('[data-result-count]').textContent = state === 'upcoming' ? `${upcomingCount} productos en próximas tandas` : `${matching.length} ${matching.length === 1 ? 'oferta activa' : 'ofertas activas'}`;
      this.querySelector('[data-shown-count]').textContent = matching.length ? `Mostrando ${shown} de ${matching.length} ofertas activas` : '';
      this.querySelector('[data-empty]').hidden = visibleWeeks > 0;
      this.querySelector('[data-empty-title]').textContent = state === 'ended' ? 'EL BLACK HA TERMINADO.' : 'EL BLACK SIGUE CRECIENDO.';
      this.querySelector('[data-empty-copy]').textContent = state === 'ended' ? 'Gracias por entrenar con AKON. Descubre todo el material de nuestro catálogo.' : 'Explora otra semana para descubrir las ofertas y las próximas tandas.';
    }
    updateBanner(state) {
      if (this.isLanding) return;
      const current = this.querySelector('[data-banner-current]');
      if (!current) return;
      const index = state === 'active' ? Math.max(1, this.weeks.filter(week => this.now() >= week.start).length) : 1;
      if (Number(current.dataset.bannerCurrent) === index) return;
      const template = this.querySelector(`template[data-banner-index="${index}"]`);
      if (!template) return;
      current.replaceChildren(template.content.cloneNode(true));
      current.dataset.bannerCurrent = String(index);
    }
    updateState() { this.dataset.state = this.state(); this.renderProducts(); this.tick(); }
    tick() {
      if (!this.isPreview && [this.start, this.end, ...this.weeks.map(week => week.start)].some(time => this.loadedAt < time && this.now() >= time)) {
        clearInterval(this.timer);
        window.location.reload();
        return;
      }
      const state = this.state();
      paintClock(this.clock, ((state === 'upcoming' ? this.start : this.end) - this.now()) / 1000, 'data-time');
      this.weeks.forEach(week => paintClock(week.clock, (week.start - this.now()) / 1000, 'data-week-time'));
      if (!this.isLanding) {
        this.querySelector('[data-countdown-caption]').textContent = state === 'upcoming' ? 'TODO EMPIEZA EN' : state === 'ended' ? 'NOS VEMOS EN EL PRÓXIMO BLACK' : 'EL BLACK TERMINA EN';
        this.querySelector('[data-campaign-note]').textContent = state === 'upcoming' ? 'Primeras ofertas el 4 de noviembre a las 14:00.' : state === 'ended' ? 'La campaña de Black Friday 2026 ha terminado.' : 'Tienes hasta el 29. No lo dejes para el último día.';
      }
      const signature = [state, ...this.weeks.map(week => this.now() >= week.start ? '1' : '0'), ...this.products.map(product => this.eligible(product) ? '1' : '0')].join('');
      if (this.signature !== signature) {
        this.signature = signature;
        this.updateBanner(state);
        this.dataset.state = state;
        this.renderProducts();
      }
    }
  }
  customElements.define('akon-black-friday', AkonBlackFriday);
})();
